import { render, staticRenderFns } from "./indexThird.vue?vue&type=template&id=66a99774&scoped=true&"
import script from "./indexThird.vue?vue&type=script&lang=js&"
export * from "./indexThird.vue?vue&type=script&lang=js&"
import style0 from "./indexThird.vue?vue&type=style&index=0&id=66a99774&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a99774",
  null
  
)

export default component.exports